import { pickerController } from '@ionic/vue';
import utils from '@/services/utils/Utils';
import dayjs from 'dayjs';
import {
  roundToFiveMinutes,
  generateFiveMinuteIntervals,
} from '@/services/utils/dateUtils';

const MACHINE_FORMAT = 'YYYY-MM-DD[T]HH:mm';
const POSSIBLE_MINUTES = generateFiveMinuteIntervals();

const mixinReportComponentsCommon = {
  methods: {
    setNow(prop, selectedDay) {
      // don't override date if it already exists
      if (this[prop]) return;

      // Get current time and round to nearest 5 minutes
      let now = dayjs();
      const minute = now.minute();
      const roundedMinute = roundToFiveMinutes(minute);

      let rounded = now.minute(roundedMinute);

      // Fix hour if minutes rolled over
      if (roundedMinute === 60) {
        rounded = rounded.add(1, 'hour').minute(0);
      }

      const selectedDayObj = dayjs(selectedDay);

      // Combine selectedDay's date with the rounded current time
      rounded = selectedDayObj
        .hour(rounded.hour())
        .minute(rounded.minute())
        .second(0);

      this.$emit(`update:${prop}`, rounded.format(MACHINE_FORMAT));
    },

    formatForDisplay(date, selectedDay = null) {
      // should not occur, but just in case
      if (!date) return '';

      if (!selectedDay || dayjs(date).isSame(selectedDay, 'day')) {
        return dayjs(date).format('HH:mm');
      }

      return dayjs(date).format('DD/MM/YYYY HH:mm');
    },

    onItemClick() {
      this.setNow('date', this.selectedDay);

      this.$nextTick(() => {
        this.openSinglePicker();
      });
    },

    async openSinglePicker() {
      // by default set date to 1 hour
      let selectedDates = [1, 0];
      if (this.date) {
        // if already set date, re-use it
        const date = dayjs(this.date);
        selectedDates = [date.hour().toString(), date.minute().toString()];
      }

      const picker = await pickerController.create({
        columns: utils.generatePickerColumns(
          selectedDates[0],
          selectedDates[1],
          POSSIBLE_MINUTES,
        ),
        buttons: [
          {
            text: 'Supprimer',
            handler: () => {
              this.$emit(`update:date`, null);
            },
          },
          {
            text: 'Valider',
            handler: time => {
              const newDate = dayjs(this.selectedDay)
                .hour(time.hours.value)
                .minute(time.minutes.value)
                .toISOString();

              this.$emit('update:date', newDate);
            },
          },
        ],
      });

      await picker.present();
    },
  },
};

export { mixinReportComponentsCommon };
